import React from 'react';

import Checkbox from '@mui/material/Checkbox';

import ExpandableCard from 'components/ExpandableCard';

import { useField } from 'app-components/flux/transaction-rules/transactionRulesFormHooks';

import useStyles from '../styles';

import ReviewedSection from 'containers/Settings/ChildPages/RulesSimplifi/targetConditions/ReviewedSection';

function ReviewedTarget() {
  // const classes = useStyles()
  const { value, onValueChange } = useField('reviewedTarget');

  return <ReviewedSection selected={value} setSelected={onValueChange} />;
}

export function ReviewedTargetCard(props: any) {
  const { classes, theme } = useStyles();
  const { value, onValueChange } = useField('isEnabledReviewedTarget');

  const toggleEnabled = () => {
    onValueChange(!value);
  };

  return (
    <ExpandableCard
      id='rule-reviewed-target'
      className={classes.card}
      title='Mark as Reviewed'
      cardHeaderProps={{ padding: `${theme.spacing(1.5)} ${theme.spacing(2)}` }}
      titleProps={{ variant: 'subtitle2' }}
      expandIcon={<Checkbox id='rule-reviewed-target-enabled' checked={value} onClick={toggleEnabled}></Checkbox>}
      isExpanded={value || !!props.hideToggle}
      hideToggle={!!props.hideToggle}
    >
      <ReviewedTarget />
    </ExpandableCard>
  );
}
